import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { businessActions } from 'Ducks';

const ServicesProvider = ({ children }) => {
	const dispatch = useDispatch();
	const businessId = useSelector((item) => item?.user?.selectedBusinessId);

	useEffect(() => {
		if (businessId) {
			dispatch(businessActions.getBusinessRequest({ businessId }));
		}
	}, [businessId]);

	return <>{children}</>;
};

export default ServicesProvider;
